/* Beibi Beauty — progressive enhancement for native Shopify forms and routes. */
(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  const routes = window.routes || {};
  const one = (s, p = document) => p.querySelector(s);
  const all = (s, p = document) => [...p.querySelectorAll(s)];
  let bagOpener = null;
  let cartBusy = false;
  const bag = () => one('#BeibiBag');
  function showError(form, message) {
    const box = one('[data-form-error], [data-cart-error]', form);
    if (box) { box.hidden = false; box.textContent = message; }
  }
  async function openBag(opener, refresh = false) {
    const dialog = bag();
    if (!dialog) { location.href = routes.cart_url || root + 'cart'; return; }
    if (refresh) {
      if (cartBusy) return;
      cartBusy = true;
      opener?.setAttribute('aria-busy', 'true');
      try { await refreshBag(); }
      catch (_) {
        showError(dialog, 'No pudimos actualizar la bolsa. Recarga la página antes de continuar al pago.');
        all('.bb-cart-form button[name=checkout]').forEach(button => { button.disabled = true; });
      }
      finally { cartBusy = false; opener?.removeAttribute('aria-busy'); }
    }
    if (!dialog.open) bagOpener = opener || document.activeElement;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('bb-bag-open');
    document.body.classList.add('bb-bag-open');
    one('[data-close-bag]', dialog)?.focus();
  }
  function closeBag() {
    bag()?.close();
    document.documentElement.classList.remove('bb-bag-open');document.body.classList.remove('bb-bag-open');
    bagOpener?.focus?.();
  }
  function cartUrl() {
    const url = new URL(routes.cart_url || root + 'cart', location.origin);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  }
  function updateCartView(parsed) {
    const next = parsed.querySelector('#BeibiBag');
    const current = bag();
    if (!next || !current || !next.querySelector('[data-cart-count]')) return false;
    const notes = all('.bb-cart-content textarea[name=note]').map(el => [el.id, el.value]);
    const scroll = one('.cart-items', current)?.scrollTop || 0;
    current.innerHTML = next.innerHTML;
    const page = one('[data-cart-page]');
    if (page) {
      const nextPage = parsed.querySelector('[data-cart-page]');
      if (nextPage) page.innerHTML = nextPage.innerHTML;
      else {
        page.innerHTML = next.innerHTML;
        const form = one('form', page); if (form) form.id = 'bb-cart-page';
        all('[id]', page).forEach(el => { el.id = el.id.replace('drawer-', 'page-').replace('BagTitle', 'BagPageTitle'); });
        all('label[for]', page).forEach(el => { el.htmlFor = el.htmlFor.replace('drawer-', 'page-'); });
        const close = one('[data-close-bag]', page);
        if (close) { const link = document.createElement('a'); link.href = root + 'collections/all'; link.className = 'bb-cart-continue'; link.textContent = 'Continue shopping'; close.replaceWith(link); }
      }
    }
    notes.forEach(([id, value]) => { const el = document.getElementById(id); if (el) el.value = value; });
    const list = one('.cart-items', current); if (list) list.scrollTop = scroll;
    const count = next.querySelector('[data-cart-count]').dataset.cartCount;
    all('[data-bag-count]').forEach(el => { el.textContent = count; });
    return true;
  }
  async function refreshBag() {
    const id = bag()?.dataset.sectionId || 'bb-cart-drawer';
    const url = new URL(location.href); url.searchParams.set('sections', id);
    try {
      const res = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (res.ok) {
        const sections = await res.json();
        if (sections[id] && updateCartView(new DOMParser().parseFromString(sections[id], 'text/html'))) return;
      }
    } catch (_) { /* The mutation already succeeded: retry the view, never the add. */ }
    // A draft theme or a section-rendering failure can return null with HTTP 200.
    // Recover the same native cart from a full theme render without leaving the product.
    const res = await fetch(cartUrl(), {credentials:'same-origin',headers:{Accept:'text/html'},cache:'no-store'});
    if (res.ok && updateCartView(new DOMParser().parseFromString(await res.text(), 'text/html'))) return;
    throw new Error('Tu carrito se guardó. Recarga la página para ver el contenido actualizado.');
  }
  async function addItems(payload, form, trigger) {
    if (cartBusy) return;
    cartBusy = true;
    const button = trigger || one('button[type=submit]', form);
    const disabled = button?.disabled;
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    one('[data-form-error], [data-cart-error]', form)?.setAttribute('hidden', '');
    try {
      const formData = payload instanceof FormData;
      const res = await fetch((routes.cart_add_url || root + 'cart/add') + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: formData ? { Accept: 'application/json' } : { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: formData ? payload : JSON.stringify(payload)
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'No se pudo agregar el producto.');
      try { await refreshBag(); await openBag(button); }
      catch (_) { location.assign(cartUrl()); }
      document.dispatchEvent(new CustomEvent('beibi:cart-updated', { detail: data }));
    } catch (error) { showError(form, error.message || 'Revisa tu conexión e inténtalo otra vez.'); }
    finally { cartBusy = false; if (button) { button.disabled = disabled; button.removeAttribute('aria-busy'); } }
  }
  async function changeLine(key, quantity, trigger) {
    if (cartBusy || !Number.isInteger(quantity) || quantity < 0) return;
    const container = trigger?.closest('.bb-cart-content') || bag();
    const fromPage = !!trigger?.closest('[data-cart-page]');
    const focusId = trigger?.id;
    const direction = trigger?.dataset.cartStep;
    const oldInput = all('[data-cart-quantity]', container).find(el => el.dataset.key === key);
    const oldQuantity = oldInput?.defaultValue;
    const controls = all('.bb-cart-content button, .bb-cart-content input').map(el => [el, el.disabled]);
    cartBusy = true; container.setAttribute('aria-busy', 'true');
    controls.forEach(([el]) => { el.disabled = true; });
    one('[data-cart-error]', container)?.setAttribute('hidden', '');
    try {
      const res = await fetch((routes.cart_change_url || root + 'cart/change') + '.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity})});
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'No se pudo cambiar la cantidad.');
      await refreshBag();
      const current = fromPage ? one('[data-cart-page]') : bag();
      const row = all('[data-line-key]', current).find(el => el.dataset.lineKey === key);
      const focusTarget = direction && row ? all('[data-cart-step]',row).find(el=>el.dataset.cartStep===direction) : focusId ? document.getElementById(focusId) : null;
      (focusTarget && !focusTarget.disabled ? focusTarget : one('[data-close-bag]',current) || one('h2',current))?.focus();
      document.dispatchEvent(new CustomEvent('beibi:cart-updated', {detail:data}));
    } catch (e) { if (oldInput) oldInput.value = oldQuantity; showError(container, e.message); }
    finally { cartBusy = false; container.removeAttribute('aria-busy'); controls.forEach(([el, disabled])=>{if(el.isConnected)el.disabled=disabled;}); }
  }
  function displayGallery(gallery, index) {
    const thumbs = all('[data-gallery-thumb]', gallery); if (!thumbs.length) return;
    index = (index + thumbs.length) % thumbs.length;
    const target = thumbs[index];
    gallery.dataset.index = String(index);
    all('.bb-gallery-video', gallery).forEach(el => el.remove());
    const image = one('[data-gallery-main]', gallery);
    image.hidden = false; image.src = target.dataset.src; image.alt = target.dataset.alt;
    image.classList.toggle('is-product', target.dataset.kind === 'product');
    if (target.dataset.mediaId) {
      const template = document.getElementById(target.dataset.mediaId);
      if (template) { const box = document.createElement('div'); box.className = 'bb-gallery-video'; box.append(template.content.cloneNode(true)); one('.pdp-gallery__stage',gallery).prepend(box); image.hidden=true; }
    }
    const label = String(index + 1).padStart(2,'0');
    one('[data-gallery-counter]',gallery).textContent = label + ' / ' + String(thumbs.length).padStart(2,'0');
    one('[data-gallery-caption]',gallery).textContent = label + ' / ' + target.dataset.alt;
    thumbs.forEach((t,n) => { t.classList.toggle('is-active', n===index); t.setAttribute('aria-pressed',String(n===index)); });
  }
  function filterCatalog(catalog) {
    const family = catalog.dataset.family || 'all';
    const finish = one('[data-filter-finish]',catalog)?.value || 'all';
    const color = one('[data-filter-color]',catalog)?.value || 'all';
    const cards = all('[data-catalog-grid] > .product-card',catalog);
    let count = 0;
    cards.forEach(card => {
      const f=card.dataset.family;
      const matchFamily=family==='all'||family===f||(family==='lips'&&['silk','liner','gloss'].includes(f));
      const matchFinish=finish==='all'||finish==='glossy'&&['silk','gloss'].includes(f)||finish==='cream'&&['liner','blush'].includes(f);
      // Makeup families contain several shades; filtering retains a family with any matching tone.
      const colors={silk:['red','pink','neutral','orange'],liner:['red','pink','neutral','orange'],gloss:['red','pink','neutral'],blush:['red','pink','neutral','orange']};
      const matchColor=color==='all'||(colors[f]||[]).includes(color);
      card.hidden=!(matchFamily&&matchFinish&&matchColor); if(!card.hidden)count++;
    });
    one('[data-catalog-count]',catalog).textContent=count+' products & families';
    one('[data-catalog-empty]',catalog).hidden=count>0;
    const sort=one('[data-sort]',catalog)?.value;
    const grid=one('[data-catalog-grid]',catalog);
    cards.sort((a,b)=>sort==='price-low'?Number(a.dataset.price)-Number(b.dataset.price):sort==='price-high'?Number(b.dataset.price)-Number(a.dataset.price):Number(a.dataset.order)-Number(b.dataset.order)).forEach(c=>grid.append(c));
    all('[data-filter-family]',catalog).forEach(b=>{const active=b.dataset.filterFamily===family;b.classList.toggle('is-active',active);b.setAttribute('aria-pressed',String(active));});
  }
  function init(scope=document) {
    const glossTone = new URL(location.href).searchParams.get('bb_tone');
    const previews = all('[data-gloss-preview]', scope);
    const selectedPreview = previews.find(panel => panel.dataset.glossPreview === glossTone);
    if (selectedPreview) {
      if (selectedPreview.dataset.productUrl) { location.replace(selectedPreview.dataset.productUrl); return; }
      previews.forEach(panel => panel.hidden = panel !== selectedPreview);
      all('[data-catalog]', scope).forEach(catalog => catalog.hidden = true);
    }

    all('[data-catalog]',scope).forEach(c=>{
      if(c.dataset.ready)return;c.dataset.ready='true';
      c.dataset.family=new URL(location.href).searchParams.get('bb_family')||c.dataset.defaultFamily||'all';
      all('[data-catalog-grid] > .product-card',c).forEach((el,i)=>el.dataset.order=String(i));filterCatalog(c);
    });
    all('[data-gallery]',scope).forEach(g=>displayGallery(g,0));
    const dialog=bag();if(dialog&&!dialog.dataset.ready){dialog.dataset.ready='true';dialog.addEventListener('close',()=>{document.documentElement.classList.remove('bb-bag-open');document.body.classList.remove('bb-bag-open');});dialog.addEventListener('cancel',()=>{document.documentElement.classList.remove('bb-bag-open');document.body.classList.remove('bb-bag-open');bagOpener?.focus?.();});dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)closeBag();}});}
  }
  document.addEventListener('submit',e=>{
    const form=e.target;
    if(form.matches('[data-add-form]')){e.preventDefault();addItems(new FormData(form),form,e.submitter);}
    else if(form.matches('.bb-cart-form')&&cartBusy)e.preventDefault();
  });
  document.addEventListener('click',e=>{
    const t=e.target.closest('button,a');if(!t)return;
    if(t.matches('[data-open-bag]')){e.preventDefault();openBag(t,true);return;}
    if(t.matches('[data-close-bag]')){closeBag();return;}
    if(t.matches('[data-remove-line]')){e.preventDefault();changeLine(t.dataset.removeLine,0,t);return;}
    if(t.matches('[data-cart-step]')){const input=one('[data-cart-quantity]',t.parentElement);const next=Number(input.value)+Number(t.dataset.cartStep)*(Number(input.step)||1);if(next>=Number(input.min)&&(!input.max||next<=Number(input.max)))changeLine(input.dataset.key,next,t);return;}
    if(t.matches('[data-cart-recommendation]')){addItems({items:[{id:Number(t.dataset.cartRecommendation),quantity:Number(t.dataset.quantity)||1}]},t.closest('.bb-cart-content'),t);return;}
    if(t.matches('[data-quantity-step]')){const input=one('input',t.parentElement);const step=Number(input.step)||1;const next=Number(input.value)+Number(t.dataset.quantityStep)*step;input.value=String(Math.max(Number(input.min)||1,Math.min(Number(input.max)||Infinity,next)));return;}
    if(t.matches('[data-gallery-thumb]')){const g=t.closest('[data-gallery]');displayGallery(g,all('[data-gallery-thumb]',g).indexOf(t));return;}
    if(t.matches('[data-gallery-step]')){const g=t.closest('[data-gallery]');displayGallery(g,Number(g.dataset.index||0)+Number(t.dataset.galleryStep));return;}
    if(t.matches('[data-community-scroll]')){const track=one('.community-section__grid',t.closest('.community-section'));track.scrollBy({left:Number(t.dataset.communityScroll)*track.clientWidth*.82,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});return;}
    if(t.matches('[data-wardrobe-shade]')){const w=t.closest('.shade-wardrobe');all('[data-wardrobe-shade]',w).forEach(b=>{b.classList.toggle('is-active',b===t);b.setAttribute('aria-pressed',String(b===t));});one('[data-wardrobe-name]',w).textContent=t.dataset.tone;one('[data-wardrobe-description]',w).textContent=t.dataset.shade;one('[data-wardrobe-link]',w).href=t.dataset.url;return;}
    if(t.matches('[data-card-shade]')){const card=t.closest('[data-card]');all('[data-card-link]',card).forEach(a=>a.href=t.dataset.url);one('.product-card__primary',card).src=t.dataset.image;one('.product-card__primary',card).alt=t.dataset.title;one('.product-card__hover',card).src=t.dataset.hover||t.dataset.image;one('[data-card-price]',card).textContent=t.dataset.price;one('[data-card-compare]',card).textContent=t.dataset.compare;one('[data-card-tone]',card).textContent=t.dataset.title;card.dataset.price=t.dataset.cents;const input=one('input[name=id]',card);if(input)input.value=t.dataset.id;const btn=one('button[type=submit]',card);if(btn)btn.disabled=t.dataset.available!=='true';const label=one('[data-add-label]',card);if(label)label.textContent=t.dataset.unlinked==='true'?'Disponible muy pronto':t.dataset.available==='true'?'Quick add':'Agotado';all('[data-card-shade]',card).forEach(b=>b.setAttribute('aria-pressed',String(b===t)));return;}
    if(t.matches('[data-filter-family]')){const c=t.closest('[data-catalog]');c.dataset.family=t.dataset.filterFamily;const url=new URL(location.href);url.searchParams.set('bb_family',t.dataset.filterFamily);history.replaceState({},'',url);filterCatalog(c);return;}
    if(t.matches('[data-add-pair]')){let box=one('[data-form-error]',t.parentElement);if(!box){box=document.createElement('p');box.dataset.formError='';box.setAttribute('role','alert');t.after(box);}addItems({items:[{id:Number(t.dataset.first),quantity:1},{id:Number(t.dataset.second),quantity:1}]},t.parentElement,t);}
  });
  document.addEventListener('change',e=>{
    const t=e.target;
    if(t.matches('[data-cart-quantity]')){if(t.checkValidity())changeLine(t.dataset.key,Number(t.value),t);else{t.reportValidity();t.value=t.defaultValue;}}
    if(t.matches('[data-variant-select]')){const url=new URL(t.dataset.productUrl,location.origin);url.searchParams.set('variant',t.value);location.assign(url);}
    if(t.matches('[data-filter-color],[data-filter-finish],[data-sort]'))filterCatalog(t.closest('[data-catalog]'));
  });
  window.addEventListener('pageshow', async event => {
    if (!event.persisted) return;
    // Browsers restore the previous DOM, including stale totals and select values.
    all('[data-variant-select]').forEach(select => {
      const selected = [...select.options].find(option => option.defaultSelected);
      if (selected) select.value = selected.value;
    });
    if (cartBusy) return;
    cartBusy = true;
    try { await refreshBag(); }
    catch (_) {
      all('.bb-cart-form button[name=checkout]').forEach(button => { button.disabled = true; });
      all('.bb-cart-content').forEach(content => showError(content, 'Recarga la página para actualizar la bolsa antes de continuar al pago.'));
    }
    finally { cartBusy = false; }
  });
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('keydown',e=>{if(e.key==='Enter'&&e.target.matches('[data-cart-quantity]')){e.preventDefault();e.target.blur();}if(e.key==='Escape')all('.shop-menu[open]').forEach(d=>d.removeAttribute('open'));});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
})();
